import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import SliderSlick from 'react-slick'
import SearchBar from '../commons/SearchBar/SearchBar.container'
import Slider from '../../components/Slider'
import SliderHomeResponsive from '../../components/Slider/responsive'
import Imis from '../commons/SliderMarketReports/imi'
import News from './components/Noticias'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import Banner from './components/banner'
import { translate } from 'react-translate'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'
import { ServicesWidget } from '../commons/ServicesWidget/ServicesWidget.component'
import { servicesByFocus } from '../commons/constants'

import './components/SliderResponsive/SliderResponsive.scss'

@translate('Home')
class PageHome extends Component {

  state = {
    currentPurposeOption: undefined,
  }

  bannerNext(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderBanners.slickNext()
  }
  bannerPrevious(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.sliderBanners.slickPrev()
  }

  UNSAFE_componentWillMount() {
    this.props.didMount({ id: '', name: '/'})
    window.scrollTo(0, 0)
  }

  componentDidMount(){
    window.location.hash = window.decodeURIComponent(window.location.hash)
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#')
      if (hashParts.length === 2) {
        const hash = hashParts.slice(-1)[0]
        document.querySelector(`#${hash}`).scrollIntoView()
      }
    }
    scrollToAnchor()
    window.onhashchange = scrollToAnchor
  }

  _renderStyle(img){
    let style = {
      backgroundImage: 'url(' + img + ')'
    }
    return style
  }

  handleSelectPurpose (value) {
    this.setState({ currentPurposeOption: value })
  }

  render () {

    const { relevantsList, newsList, services, banners, imis, t } = this.props

    function findBannerResponsive(element) {
      return element.image_responsive
    }

    let banner = banners.find(findBannerResponsive)

    const filteredServices = services.filter((service) => {
      const purposeFocus = `${this.state.currentPurposeOption}Focus`
      const secotrIds = servicesByFocus.filter((item) => item[purposeFocus]).map(item => item.sectorId)
      return (secotrIds.includes(service.sectorId))
    })

    const bannerSettings = {
      dots: false,
      lazyLoad: 'progressive',
      arrows: false,
      speed: 400,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      touchMove: true,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1, dots: true } },
      ]
    }

    console.log('re render ')
    return (
      <div name='top' id='top' className='container-fluid'>
        <MainBanner
          backgroundURL={'/assets/images/home-search.jpg'}
          mainTitle={t('home_main_title')}
          withoutOverlay
        >
          <SearchBar
            section={'Home'} showPurposeSelector={true} onSelectPurpose={(value) => this.handleSelectPurpose(value)}
          />
        </MainBanner>
        <ServicesWidget services={filteredServices} currentPurpose={this.state.currentPurposeOption} />
        { (banners.length > 0) ? (
          <div className='banners-home-container'>
            <div className='banners-home-title'> Proyectos destacados </div>
            <div className=''>
              <div className='banners-container' >
                <SliderSlick className='slider-banners-container' ref='sliderBanners' {...bannerSettings}>
                  {banners.map((item, index) =>
                    <Col md={4} sm={6} key={index}>
                      <div className='slider-banner-item-wrapper' key={index}><Banner item={item} /></div>
                    </Col>
                  )}
                </SliderSlick>
                <div className='banners-slider-buttons'>
                  <div className='banners-left-buttons'>
                    <a onClick={(e) => {this.bannerPrevious(e)}}>
                      <i className='fa fa-angle-left fa-2x' aria-hidden='true'></i>
                    </a>
                  </div>
                  <div className='banners-right-buttons'>
                    <a onClick={(e) => {this.bannerNext(e)}}>
                      <i className='fa fa-angle-right fa-2x' aria-hidden='true'></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : ''
        }
        <div className='slider-container'>
          <div className='text-center title-slide'>{t('Propiedades_Destacadas')}</div>
          <div className='hidden-xs'>
            <Slider properties={relevantsList}/>
          </div>
          <div className='visible-xs box-slider'>
            <SliderHomeResponsive items={relevantsList}/>
          </div>
        </div>
        {/* <div className='directorio-home-container'>
          <div className='main-directors hidden-xs'>
            <div className='background-overlay'>
              <h1 className='directors-phrase'>El secreto de nuestro éxito es la especialización de cada área</h1>
              <h3>Diego Cazes & Luis José Ramos</h3>
            </div>
          </div>
          <Brokers brokers={directors} section={t('La_Empresa')}/>
        </div> */}
        <Imis imis={imis}/>
        {(newsList.length > 0) ?
          <div className='ljr-bg-grey'>
            <News news={newsList} />
          </div>
        : '' }
        <div className='form-container' id='contact-form' name='contact-form'>
          <ContactForm />
        </div>
      </div>
    )
  }
}

export default PageHome



// WEBPACK FOOTER //
// ./src/features/PageHome/PageHome.component.js